module.exports = {
  displayName: 'ERP',
  description: '3rd party integrations',
  sortOrder: 4,
  name: 'erp',
  documentKey: 'erp',
  sections: {
  },
};
